import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Newspaper, LogOut } from "lucide-react";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { API, formatApiError } from "@/lib/newsUtils";
import { OnboardingFlow } from "@/components/OnboardingFlow";

export default function Onboarding() {
  const { user, logout, refreshUser } = useAuth();
  const navigate = useNavigate();

  const onComplete = async (domains, frequency) => {
    try {
      const { data } = await axios.post(`${API}/me/sources/bulk`, { domains });
      if (!data.added || data.added.length === 0) {
        const failedNote = data.failed && data.failed.length ? ` No se detectó el feed de: ${data.failed.join(", ")}.` : "";
        toast.error(`No pudimos detectar el feed de esos medios.${failedNote} Prueba con otros.`);
        throw new Error("none-added");
      }
      if (data.failed && data.failed.length) {
        toast.warning(`No se pudieron añadir: ${data.failed.join(", ")}. Podrás añadirlos más tarde.`);
      }
      await axios.patch(`${API}/me/settings`, { digest_frequency: frequency });
      await axios.post(`${API}/me/onboard`);
      await refreshUser();
      toast.success(`¡Listo! Añadimos ${data.added.length} medio(s).`);
      navigate("/");
    } catch (err) {
      if (err?.message !== "none-added") {
        toast.error(formatApiError(err.response?.data?.detail, "No se pudo completar. Inténtalo de nuevo."));
      }
      throw err;
    }
  };

  return (
    <div className="min-h-screen bg-background">
      <header className="border-b border-border">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 py-4 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="w-9 h-9 bg-primary flex items-center justify-center">
              <Newspaper className="w-5 h-5 text-white" />
            </div>
            <span className="font-heading text-lg font-black tracking-tight">NEWS DIGEST</span>
          </div>
          <Button variant="ghost" onClick={logout} data-testid="logout-button"
            className="rounded-none gap-2 text-muted-foreground hover:text-foreground">
            <LogOut className="w-4 h-4" /> Salir
          </Button>
        </div>
      </header>

      <OnboardingFlow username={user?.username} onComplete={onComplete} />
    </div>
  );
}
